module.exports = __webpack_public_path__ + "img/user.2b83c92c.png";